const moduleNameKey = "lookbackAndPollingFields";

export const lookbackAndPollingFieldsEn = {
  [moduleNameKey]: {
    lookbackLabel: "Lookback",
    lookbackPlaceholder: "Select lookback",
    noLookbacks: "No lookback options found",
    pollingIntervalLabel: "Polling interval",
    pollingIntervalPlaceholder: "Select refresh interval",
    noPollingIntervals: "No polling intervals found",
    duration5Minutes: "5 minutes",
    duration15Minutes: "15 minutes",
    duration30Minutes: "30 minutes",
    duration1Hour: "1 hour",
    duration2Hours: "2 hours",
    duration4Hours: "4 hours",
    duration8Hours: "8 hours",
    duration24Hours: "24 hours",
    duration1Week: "1 week",
    duration1Month: "1 month",
    polling5Seconds: "5 seconds",
    polling15Seconds: "15 seconds",
    polling30Seconds: "30 seconds",
    polling1Minute: "1 minute",
    polling5Minutes: "5 minutes",
    polling15Minutes: "15 minutes",
    polling30Minutes: "30 minutes",
  },
};

export const lookbackAndPollingFieldsPtBr = {
  [moduleNameKey]: {
    lookbackLabel: "Janela de leitura",
    lookbackPlaceholder: "Selecione a janela",
    noLookbacks: "Nenhuma janela de leitura encontrada",
    pollingIntervalLabel: "Intervalo de atualização",
    pollingIntervalPlaceholder: "Selecione o intervalo de atualização",
    noPollingIntervals: "Nenhum intervalo de atualização encontrado",
    duration5Minutes: "5 minutos",
    duration15Minutes: "15 minutos",
    duration30Minutes: "30 minutos",
    duration1Hour: "1 hora",
    duration2Hours: "2 horas",
    duration4Hours: "4 horas",
    duration8Hours: "8 horas",
    duration24Hours: "24 horas",
    duration1Week: "1 semana",
    duration1Month: "1 mês",
    polling5Seconds: "5 segundos",
    polling15Seconds: "15 segundos",
    polling30Seconds: "30 segundos",
    polling1Minute: "1 minuto",
    polling5Minutes: "5 minutos",
    polling15Minutes: "15 minutos",
    polling30Minutes: "30 minutos",
  },
};

export const lookbackAndPollingFieldsDe = {
  [moduleNameKey]: {
    lookbackLabel: "Rückblick",
    lookbackPlaceholder: "Rückblick wählen",
    noLookbacks: "Keine Rückblicke gefunden",
    pollingIntervalLabel: "Aktualisierungsintervall",
    pollingIntervalPlaceholder: "Intervall wählen",
    noPollingIntervals: "Keine Aktualisierungsintervalle gefunden",
    duration5Minutes: "5 Minuten",
    duration15Minutes: "15 Minuten",
    duration30Minutes: "30 Minuten",
    duration1Hour: "1 Stunde",
    duration2Hours: "2 Stunden",
    duration4Hours: "4 Stunden",
    duration8Hours: "8 Stunden",
    duration24Hours: "24 Stunden",
    duration1Week: "1 Woche",
    duration1Month: "1 Monat",
    polling5Seconds: "5 Sekunden",
    polling15Seconds: "15 Sekunden",
    polling30Seconds: "30 Sekunden",
    polling1Minute: "1 Minute",
    polling5Minutes: "5 Minuten",
    polling15Minutes: "15 Minuten",
    polling30Minutes: "30 Minuten",
  },
};

export const lookbackAndPollingFieldsZhHans = {
  [moduleNameKey]: {
    lookbackLabel: "回溯时间",
    lookbackPlaceholder: "选择回溯时间",
    noLookbacks: "未找到回溯时间",
    pollingIntervalLabel: "轮询间隔",
    pollingIntervalPlaceholder: "选择刷新间隔",
    noPollingIntervals: "未找到轮询间隔",
    duration5Minutes: "5分钟",
    duration15Minutes: "15分钟",
    duration30Minutes: "30分钟",
    duration1Hour: "1小时",
    duration2Hours: "2小时",
    duration4Hours: "4小时",
    duration8Hours: "8小时",
    duration24Hours: "24小时",
    duration1Week: "1周",
    duration1Month: "1个月",
    polling5Seconds: "5秒",
    polling15Seconds: "15秒",
    polling30Seconds: "30秒",
    polling1Minute: "1分钟",
    polling5Minutes: "5分钟",
    polling15Minutes: "15分钟",
    polling30Minutes: "30分钟",
  },
};

export const lookbackAndPollingFieldsIt = {
  [moduleNameKey]: {
    lookbackLabel: "Periodo di osservazione",
    lookbackPlaceholder: "Seleziona periodo",
    noLookbacks: "Nessun periodo di osservazione trovato",
    pollingIntervalLabel: "Intervallo di aggiornamento",
    pollingIntervalPlaceholder: "Seleziona intervallo",
    noPollingIntervals: "Nessun intervallo di aggiornamento trovato",
    duration5Minutes: "5 minuti",
    duration15Minutes: "15 minuti",
    duration30Minutes: "30 minuti",
    duration1Hour: "1 ora",
    duration2Hours: "2 ore",
    duration4Hours: "4 ore",
    duration8Hours: "8 ore",
    duration24Hours: "24 ore",
    duration1Week: "1 settimana",
    duration1Month: "1 mese",
    polling5Seconds: "5 secondi",
    polling15Seconds: "15 secondi",
    polling30Seconds: "30 secondi",
    polling1Minute: "1 minuto",
    polling5Minutes: "5 minuti",
    polling15Minutes: "15 minuti",
    polling30Minutes: "30 minuti",
  },
};

export const lookbackAndPollingFieldsEs = {
  [moduleNameKey]: {
    lookbackLabel: "Periodo de búsqueda",
    lookbackPlaceholder: "Selecciona el periodo",
    noLookbacks: "No se encontraron periodos de búsqueda",
    pollingIntervalLabel: "Intervalo de actualización",
    pollingIntervalPlaceholder: "Seleccionar intervalo",
    noPollingIntervals: "No se encontraron intervalos de actualización",
    duration5Minutes: "5 minutos",
    duration15Minutes: "15 minutos",
    duration30Minutes: "30 minutos",
    duration1Hour: "1 hora",
    duration2Hours: "2 horas",
    duration4Hours: "4 horas",
    duration8Hours: "8 horas",
    duration24Hours: "24 horas",
    duration1Week: "1 semana",
    duration1Month: "1 mes",
    polling5Seconds: "5 segundos",
    polling15Seconds: "15 segundos",
    polling30Seconds: "30 segundos",
    polling1Minute: "1 minuto",
    polling5Minutes: "5 minutos",
    polling15Minutes: "15 minutos",
    polling30Minutes: "30 minutos",
  },
};

export const lookbackAndPollingFieldsNl = {
  [moduleNameKey]: {
    lookbackLabel: "Terugkijkperiode",
    lookbackPlaceholder: "Selecteer een terugkijkperiode",
    noLookbacks: "Geen terugkijkperiodes gevonden",
    pollingIntervalLabel: "Polling-interval",
    pollingIntervalPlaceholder: "Polling-interval kiezen",
    noPollingIntervals: "Geen polling-intervallen gevonden",
    duration5Minutes: "5 minuten",
    duration15Minutes: "15 minuten",
    duration30Minutes: "30 minuten",
    duration1Hour: "1 uur",
    duration2Hours: "2 uur",
    duration4Hours: "4 uur",
    duration8Hours: "8 uur",
    duration24Hours: "24 uur",
    duration1Week: "1 week",
    duration1Month: "1 maand",
    polling5Seconds: "5 seconden",
    polling15Seconds: "15 seconden",
    polling30Seconds: "30 seconden",
    polling1Minute: "1 minuut",
    polling5Minutes: "5 minuten",
    polling15Minutes: "15 minuten",
    polling30Minutes: "30 minuten",
  },
};

export const lookbackAndPollingFieldsTr = {
  [moduleNameKey]: {
    lookbackLabel: "Geriye bakma",
    lookbackPlaceholder: "Yeniden incelemeyi seçin",
    noLookbacks: "Hiçbir geriye bakma bulunamadı",
    pollingIntervalLabel: "Yoklama aralığı",
    pollingIntervalPlaceholder: "Yenileme aralığını seçin",
    noPollingIntervals: "Hiçbir yoklama aralığı bulunamadı",
    duration5Minutes: "5 dakika",
    duration15Minutes: "15 dakika",
    duration30Minutes: "30 dakika",
    duration1Hour: "1 saat",
    duration2Hours: "2 saat",
    duration4Hours: "4 saat",
    duration8Hours: "8 saat",
    duration24Hours: "24 saat",
    duration1Week: "1 hafta",
    duration1Month: "1 ay",
    polling5Seconds: "5 saniye",
    polling15Seconds: "15 saniye",
    polling30Seconds: "30 saniye",
    polling1Minute: "1 dakika",
    polling5Minutes: "5 dakika",
    polling15Minutes: "15 dakika",
    polling30Minutes: "30 dakika",
  },
};
